module.exports = __webpack_public_path__ + "img/summary-list.02bce1d8.png";